import {AnyLinkType} from 'shared/pretty-easy-navigation/models';

export const LearnerMenu: AnyLinkType[] = [
    {
        type: 'linkGroup',
        links: [
            {
                type: 'link',
                label: 'navigation.dashboard',
                link: '/home',
                icon: 'navigation-link__home',
            },
            {
                type: 'accordionLinkGroup',
                label: 'navigation.groups_workgroups',
                icon: 'navigation-group__groups-workgroups',
                links: [
                    {
                        type: 'link',
                        label: 'navigation.groups',
                        link: '/groups/list/groups',
                        icon: 'navigation-link__list-item',
                    },
                    {
                        type: 'link',
                        label: 'navigation.workgroups',
                        link: '/groups/list/workgroups',
                        icon: 'navigation-link__list-item',
                    },
                ],
            },
            {
                type: 'link',
                label: 'navigation.my_activities',
                link: '/followed/tab/list',
                icon: 'navigation-link__my-activities',
            },
        ],
    },
    {
        type: 'linkGroup',
        links: [
            {
                type: 'link',
                label: 'navigation.legal_notice',
                link: '/informations-legales',
                icon: 'navigation-link__legal-notice',
            },
            {
                type: 'link',
                label: 'navigation.contact',
                link: '/feedback',
                icon: 'navigation-link__contact',
            },
            {
                type: 'link',
                label: 'navigation.site_map',
                link: '/page/site-map-learner',
                icon: 'navigation-link__sitemap',
            },
        ],
    },
];
